import { type LogosProps } from 'hb-builder/components/BuilderComponents/page/block/Partners/utils/instantiateLogos';
import { type BuilderComponent, type FeatureConfig } from 'hb-builder/types';
import { type Template } from 'hb-react/backoffice/types/builder/itemAttributes/partnersItemAttributes';

export interface GetItemArgumentsProps {
  component: BuilderComponent;
  features: FeatureConfig;
  template?: Template;
}

export const getColumnWidthByTemplate = (template: Template) => {
  if (
    template === 'PartnersTemplateOne' ||
    template === 'PartnersTemplateTwo'
  ) {
    return {
      _: 3 / 6,
      m: 4 / 12,
      l: 3 / 12,
      xl: 2 / 12,
    };
  }

  return undefined;
};

export const getItemArguments = ({
  component,
  features,
  template,
}: GetItemArgumentsProps): LogosProps | undefined => {
  if (template === 'PartnersTemplateOne') {
    return {
      columnWidth: getColumnWidthByTemplate(template),
      component,
      logoBackground: 'transparent',
      partnersCount: features.partners?.templateOne.partnersCount,
      template,
    };
  }

  if (template === 'PartnersTemplateTwo') {
    return {
      columnWidth: getColumnWidthByTemplate(template),
      component,
      logoBackground: 'white',
      partnersCount: features.partners?.templateTwo.partnersCount,
      template,
    };
  }

  if (template === 'PartnersTemplateThree') {
    return {
      component,
      logoBackground: 'white',
      partnersCount: features.partners?.templateThree.partnersCount,
      template,
    };
  }

  if (template === 'PartnersTemplateFour') {
    return {
      component,
      logoBackground: 'white',
      partnersCount: features.partners?.templateFour.partnersCount,
      template,
    };
  }

  if (!template) {
    return {
      columnWidth: {
        _: 6 / 6,
        m: 6 / 12,
        xl: 4 / 12,
      },
      component,
      logoBackground: 'transparent',
      partnersCount: features.partners?.partnersCount,
    };
  }
};
